import GET_ADMIN_USER_MANAGEMENT_USERS from 'graph/user/get-admin-user-management-users';

const getAdminUserManagementUsers = (): any => ({
  refetchQueries: [{ query: GET_ADMIN_USER_MANAGEMENT_USERS }]
});

export { getAdminUserManagementUsers };
